/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTallymark1 = createReactComponent("tallymark-1", "IconTallymark1", [
  ["path", { d: "M12 5l0 14", key: "svg-0" }]
]);

export { IconTallymark1 as default };
//# sourceMappingURL=IconTallymark1.js.map
